module.exports = __webpack_public_path__ + "img/part4-2.3de9d47b.png";